import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Grid from '@mui/material/Grid2';
import { 
  FeatureSource,
  ModelBase,
  PlayerObject, 
} from "@models";
import { 
  Subrace, 
} from "@dndModels";
import { SizeType } from "@dndModels/Types";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import LoadingBox from "@components/input/LoadingBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import FeatureSourceInput from "@dndComponents/FeatureSourceInput";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import DisplayObjects from "@dndComponents/display/DisplayObjects";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function SubraceEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [obj, setObj] = useState<Subrace>(api.applyWorkingOn(new Subrace()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    setFetched(true);
    if (id && id !== "") {
      setLoading(true);
      const onComplete = (res: PlayerObject[] | ModelBase[]) => {
        if (res.length === 1 && res[0] instanceof Subrace) {
          setObj(res[0].clone());
          setChangeTime(common_util.get_time_number());
        }
        setLoading(false);
      };
      const onProgress = () => {};
      api.getObjectsWithCallbacks({ 
        data_type: "subrace", filter: { _id: id },
        onComplete, onProgress 
      });
    }
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("subrace", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/subrace");
  //     });
  //   }
  // }

  const height = window.innerHeight - 105;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else { 
    return (
      <FeatureSourceInput 
        obj={obj}
        data_type="subrace"
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: FeatureSource) => {
          if (changed instanceof Subrace) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
          }
        }}
        header={
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              { disabled ?
                <>
                  <span className="header">Race:</span> <DisplayObjects type="race" ids={obj.race_ids} />
                </>
              :
                <SelectObjectBox 
                  name="Race"
                  data_type="race"
                  values={ obj.race_ids } 
                  multiple
                  disabled={disabled}
                  onChange={(ids: string[]) => {
                    const new_obj = obj;
                    new_obj.race_ids = ids;
                    setObj(new_obj);
                    setChangeTime(common_util.get_time_number());
                  }}
                />
              }
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              { disabled ?
                <>
                  { !obj.sizes.includes(8) &&
                    <>
                      <span className="header">Size:</span> 
                      { common_util.get_size_strings(obj.sizes).join(", ") } 
                    </>
                  }
                </>
              : !reloading &&
                <SelectStringBox 
                  name="Size"
                  options={["Tiny","Small","Medium","Large","Huge","Gargantuan","Size from Race"]}
                  values={common_util.get_size_strings(obj.sizes)} 
                  multiple
                  disabled={disabled}
                  onChange={(values: string[]) => {
                    const new_obj = obj;
                    const old_sizes = [...new_obj.sizes];
                    let new_sizes = common_util.get_size_numbers(values);
                    if (new_sizes.includes(8)) {
                      if (old_sizes.includes(8) && new_sizes.filter(o => o !== 8).length > 0) {
                        new_sizes = new_sizes.filter(o => o !== 8);
                        setReloading(true);
                      } else if (!old_sizes.includes(8) && new_sizes.filter(o => o === 8).length > 0) {
                        new_sizes = [8];
                        setReloading(true);
                      }
                    }
                    new_obj.sizes = new_sizes as SizeType[];
                    setObj(new_obj); 
                    setChangeTime(common_util.get_time_number());
                  }}
                />
              }
            </Grid>
          </Grid>
        }
      />
    ); 
  }
}